import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';

@Component({
    selector: 'verify-email',
    templateUrl: 'verifyEmail.component.html',
    styleUrls: ['userViews.scss']
})

export class VerifyEmailComponent implements OnInit {
    public isWaiting: boolean;
    public emailSent: boolean;

    constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute) { }

    public async ngOnInit() {
        let user = await this.authService.getCurrentUser();
        if (user.emailVerified) {
            this.route.queryParams.subscribe(params => {
                this.router.navigateByUrl(params.returnUrl || '/');
            });
        }
    }

    public async resendEmail() {
        this.isWaiting = true;
        if (await this.authService.sendEmailVerification()) {
            this.emailSent = true;
        }
        this.isWaiting = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/user/verifyEmail.component.ts